import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 md:py-32 text-center" data-testid="not-found-page">
      <div className="label-eyebrow text-secondary">404</div>
      <h1 className="mt-3 font-serif text-5xl md:text-6xl">Página no encontrada</h1>
      <p className="mt-4 text-muted-foreground">
        La ruta que buscas no existe o fue movida. Vuelve al inicio para seguir explorando.
      </p>
      <div className="mt-8 flex gap-3 justify-center flex-wrap">
        <Button asChild className="rounded-full btn-hover-lift" data-testid="notfound-home">
          <Link to="/"><Home className="h-4 w-4 mr-2" /> Ir al inicio</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-full" data-testid="notfound-properties">
          <Link to="/properties">Ver propiedades</Link>
        </Button>
      </div>
    </div>
  );
}
